<panel>
  <span *ngIf="auditLog.length == 0">{{'There is no audit history to display.' | translate | async}}</span>
  <table class="table table--full-width table--striped" *ngIf="auditLog.length > 0">
    <thead>
      <tr>
        <th>{{'Event Time' | translate | async}}</th>
        <th>{{'User' | translate | async}}</th>
        <th>{{'Change' | translate | async}}</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let audit of auditLog">
        <td style="width: 220px;">{{audit.Date | date:'medium'}}</td>
        <td><a href="mailto:{{audit.UserEmail}}" [matTooltip]="audit.UserEmail">{{audit.UserName}}</a></td>
        <td><span [matTooltip]="audit.EventDescription">{{audit.EventDescription | slice:0:130}}{{audit.EventDescription.length > 130 ? '...' : ''}}</span></td>
      </tr>
    </tbody>
  </table>
</panel>
